<template>
	<article class="itemView">
		<vue-headful :title="name.toProperCase() + ' - Where does it Go?'" />
		<header>
			<h2>{{ name }}</h2>
		</header>
		<item-section v-for="(val, key) in sections" :key="key" :pkey="key" :val="val" :item="item.content" :rates="rates"> </item-section>
	</article>
</template>
 
<script>
	import ItemSection from './ItemSection';

	export default {
		name: 'item-view',
		data() {
			return {
				sections : {
					'General'     : '',
					'Donate'      : 'Reuse, Repair, and Donate', 
					'Reuse'       : 'Reuse', 
					'Recycling'   : 'In Recycling', 
					'Foodandyard' : 'In Food & Yard Waste', 
					'Garbage'     : 'In Garbage',
					'Curbside'    : 'Special Item Pickup', 
					'Transferstation'   : 'Transfer Station', 
					'Dropoff'     : 'Drop-off Options', 
					'Hazardous'   : 'Hazardous', 
					'Caution'     : 'Caution', 
					'Didyouknow'  : 'Did you know?',
					'Binside'     : 'Special Instructions', 
					'VideoExternalComponent'  : 'Videos',
					'GeneralFootnote'  : ''
				}
			}
		},
		props: {
			'item' : Object, 
			'rates' : Array
		},
		components: {
			ItemSection
		},
		computed: {
			name() {
				return this.item.name.toLowerCase();
			}
		}
	};
</script> 



  

